import getConfig from 'next/config';
import { useApolloClient } from '@apollo/client';
import { useEffect, useState } from 'react';
import EirActionModal from '../eir-action-modal/EirActionModal';
import fetchInfo from '../../../util/fetchModalData';
import MfaOtpFields from './MfaOtpFields';
import { sendMfaOtp, validateMfaOtp } from '../../integration/getBrands.api';
import { updateDataToEshopDB } from './eirLogin.util';
import { setCookie } from '../../hooks/useCookie';

const { publicRuntimeConfig } = getConfig();

const MfaOtpModal = ({
  mfaOtpModal,
  otpUUID,
  errorModal,
  mfaSuccessModal,
  userValue,
  delivery,
  setOtpUUID,
}) => {
  const [cmsCollectionData, setCmsCollectionData] = useState({});
  const [load, setLoad] = useState(true);
  const [code, setCode] = useState('');
  const [activeCode, setActiveCode] = useState(false);
  const [valid, setValid] = useState(false);
  const [invalid, setInvalid] = useState(false);
  const [enableInput, setEnableInput] = useState(true);
  const [enableSubmit, setEnableSubmit] = useState(false);
  const [err, setErr] = useState(false);
  const graphql = useApolloClient();
  const [timer, setTimer] = useState(30);
  const [isCounting, setIsCounting] = useState(false);

  const getCmsData = async () => {
    try {
      const data = await fetchInfo({
        collectionType: 'eir-action-modals',
        modalID: 'new-mfa-otp-verification',
      });
      if (Object?.keys(data).length !== 0) {
        setLoad(false);
        setCmsCollectionData(data);
      }
    } catch (error) {
      console.error('error', error);
    }
  };

  const resendOTP = async () => {
    const data = await sendMfaOtp({ graphql, username: userValue, operation: 'LOGIN' });

    setOtpUUID(data.sendMFAOTP.uuid);
    setCode('');
    setInvalid(false);
    setValid(true);
    setErr(false);
  };
  const verifyOTP = async () => {
    try {
      setEnableSubmit(false);
      setEnableInput(false);
      setTimer(30);
      setIsCounting(true);

      const data = await validateMfaOtp({
        graphql,
        otp: code,
        otpUuid: otpUUID,
        operation: 'LOGIN',
      });

      if (data?.data?.validateMFAOTP?.mfaToken === undefined) {
        errorModal.enable();
      } else {
        if (data?.data?.validateMFAOTP?.deviceId !== undefined) {
          updateDataToEshopDB({
            deviceId: data?.data?.validateMFAOTP?.deviceId,
          });
        }
        setCookie('MFA', 'TOKEN', data?.data?.validateMFAOTP?.mfaToken);
        mfaSuccessModal.enable();
        mfaOtpModal.disable();
      }

      // Login flow
    } catch (error) {
      setValid(false);
      setInvalid(true);

      console.error(error);
    } finally {
      setEnableSubmit(true);
      setEnableInput(true);
    }
  };
  const handleChange = event => {
    setCode(event.target.value);
    if (event.target.value) {
      if (/^\d{6}$/.test(event.target.value)) {
        setEnableSubmit(true);
        setInvalid(false);
        setErr(false);
        setValid(true);
      } else {
        setInvalid(true);
        setValid(false);
        setEnableSubmit(false);
      }
    } else {
      setErr(false);
      setInvalid(false);
      setValid(false);
    }
  };

  useEffect(() => {
    let interval;
    if (isCounting && timer > 0) {
      interval = setInterval(() => {
        setTimer(prev => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      setIsCounting(false);
    }
    return () => clearInterval(interval);
  }, [isCounting, timer]);

  useEffect(() => {
    getCmsData();
  }, []);

  return (
    <EirActionModal
      id={cmsCollectionData?.attributes?.modalID || ''}
      open={mfaOtpModal.value}
      handleClose={mfaOtpModal.disable}
      iconSrc={`${publicRuntimeConfig.NEXT_PUBLIC_STRAPI}${
        cmsCollectionData?.attributes?.iconSrc?.data?.attributes?.url || ''
      }`}
      title={cmsCollectionData?.attributes?.title || ''}
      description={
        <>
          {`${
            cmsCollectionData?.attributes?.firstHalfDescription || ''
          } *******${delivery} linked to the account`}
          <MfaOtpFields
            code={code}
            setCode={setCode}
            delivery={delivery}
            activeCode={activeCode}
            setActiveCode={setActiveCode}
            valid={valid}
            setValid={setValid}
            invalid={invalid}
            enableInput={enableInput}
            timer={timer}
            isCounting={isCounting}
            handleChange={handleChange}
            verifyOTP={verifyOTP}
            resendOTP={resendOTP}
            enableSubmit={enableSubmit}
            err={err}
          />
        </>
      }
      cta={[
        {
          // text: 'Continue',
          text: cmsCollectionData?.attributes?.cta[0]?.name
            ? cmsCollectionData?.attributes?.cta[0]?.name
            : 'Continue',
          ariaLabel: cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            ? cmsCollectionData?.attributes?.cta[0]?.ariaLabel
            : '',
          type: 'solid',
          action: () => verifyOTP(),
        },
      ]}
      disableCloseOnBackdropClick
      disableCloseOnEscapeKeyDown
      disablecta={!enableSubmit}
      load={load}
    />
  );
};
export default MfaOtpModal;
